<template>
  <vs-prompt
    title="Booking Details"
    cancel-text="Cancel"
    button-cancel="border"
    @cancel="clearFields"
    button-accept="false"
    accept-text="Cancel Booking"
    @close="clearFields"
    :active.sync="activePrompt"
  >
    <vx-card
      content-color="#fff"
      card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)"
    >
      <p class="mb-3">
        <strong>Customer Name:</strong>
        {{bookingLocal.customer_name}}
      </p>
      <p class="mb-3">
        <strong>Customer Telephone:</strong>
        {{bookingLocal.customer_telephone}}
      </p>
      <p class="mb-3">
        <strong>Status:</strong>
        {{bookingLocal.status == 'active'? 'locating a ride' : bookingLocal.status}}
      </p>
      <p class="mb-3">
        <strong>Destination:</strong>
        {{bookingLocal.destination}}
      </p>
      <p class="mb-3">
        <strong>Cost:</strong>
        {{bookingLocal.quote_price}}
      </p>
      <p class="mb-3" v-if="bookingLocal.status == 'dispatched'">
        <strong>Pickup Time:</strong>
        {{bookingLocal.estimated_pickup_time}}
      </p>
    </vx-card>
  </vs-prompt>
</template>

<script>
export default {
  props: {
    displayPrompt: {
      type: Boolean,
      required: true
    },
    booking: {
      type: Object,
      required: true
    }
  },
  computed: {
    activePrompt: {
      get() {
        return this.displayPrompt;
      },
      set(value) {
        this.$emit("hideDisplayPrompt", value);
      }
    }
  },
  data() {
    return {
      bookingLocal: Object.assign({}, this.booking)
    };
  },
  methods: {
    clearFields() {
      this.bookingLocal = {};
    },
    cancelBooking() {
      console.log("cancel booking event");
    }
  }
};
</script>
